/* eslint-disable default-case */
import React, { Component } from 'react'

// lib ui
import basicStyle from '../../settings/basicStyle'
import { Row, Col } from 'antd'
import IsoWidgetsWrapper from './widgets-wrapper'
import StickerWidget from './sticker'
// redux
import { connect } from 'react-redux'
import authActions from '../../redux/auth/actions'
// sub component
import ListPageLinks from './list_page_links'
import ChartTaskOfUser from '../../components/QB86ChartComponent/ChartTaskOfUser'
import ChartTaskOfSystem from '../../components/QB86ChartComponent/ChartTaskOfSystem'
import ChartEventStatisticsByObject from '../../components/QB86ChartComponent/ChartEventStatisticsByObject'
import ChartObjectEvent from '../../components/QB86ChartComponent/ChartObjectEvent'
import ChartCollectedByTier from '../../components/QB86ChartComponent/ChartCollectedByTier'
import ChartUserTask from '../../components/QB86ChartComponent/ChartUserTask'
import ChartOrgTask from '../../components/QB86ChartComponent/ChartOrgTasks'
import ChartUserCollected from '../../components/QB86ChartComponent/ChartUserCollected'
import EventCalendar from '../../components/QB86ChartComponent/EventCalendar'
import ToDoList from '../../components/QB86ChartComponent/ToDoList'
// api
import {
    getNumberEvents,
    getNumberObjects,
    getNumberMedias,
    getNumberUsers,
} from '../../services/apis/Statitical'

class HomePage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            events: 0,
            medias: 0,
            users: 0,
            objects: 0,
        }
    }

    componentDidMount = () => {
        try {
            getNumberEvents().then(response => {
                if (response.error.code === 200) {
                    let events = response.data.total_event_existed
                    this.setState({ events })
                }
            })

            getNumberObjects().then(response => {
                if (response.error.code === 200) {
                    let objects = response.data.total_object_existed
                    this.setState({ objects })
                }
            })

            getNumberMedias().then(response => {
                if (response.error.code === 200) {
                    let medias = response.data.total_media_existed
                    this.setState({ medias })
                }
            })

            getNumberUsers().then(response => {
                if (response.error.code === 200) {
                    let users = response.data.total_user
                    this.setState({ users })
                }
            })
        } catch (ex) {}
    }

    render() {
        const { height } = this.props
        const { rowStyle, colStyle } = basicStyle

        return (
            <div className="DashboardScreen">
                <div
                    className="MainCard"
                    style={{
                        minHeight: height - 100,
                    }}
                >
                    <Col lg={6} md={9} sm={9} xs={24} style={{ padding: 20 }}>
                        <ToDoList />
                    </Col>
                    <Col
                        lg={18}
                        md={15}
                        sm={15}
                        xs={24}
                        style={{ padding: 20 }}
                    >
                        <EventCalendar />
                    </Col>
                    

                   

                    <Col lg={8} md={8} sm={8} xs={8} style={{ padding: 20 }}>
                        <ChartTaskOfUser />
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={8} style={{ padding: 20 }}>
                        <ChartTaskOfSystem />
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={8} style={{ padding: 20 }}>
                        <ChartCollectedByTier />
                    </Col>
                    <Row style={rowStyle} gutter={0} justify="start">
                        <Col lg={6} md={12} sm={12} xs={24} style={colStyle}>
                            <IsoWidgetsWrapper>
                                {/* Sticker Widget */}
                                <StickerWidget
                                    number={this.state.users + ''}
                                    text={'Người dùng'}
                                    icon="ion-ios-people"
                                    fontColor="#ffffff"
                                    bgColor="#41656b"
                                />
                            </IsoWidgetsWrapper>
                        </Col>

                        <Col lg={6} md={12} sm={12} xs={24} style={colStyle}>
                            <IsoWidgetsWrapper>
                                {/* Sticker Widget */}
                                <StickerWidget
                                    number={this.state.events + ''}
                                    text={'Sự kiện'}
                                    icon="ion-android-calendar"
                                    fontColor="#ffffff"
                                    bgColor="#508180"
                                />
                            </IsoWidgetsWrapper>
                        </Col>
                        <Col lg={6} md={12} sm={12} xs={24} style={colStyle}>
                            <IsoWidgetsWrapper>
                                {/* Sticker Widget */}
                                <StickerWidget
                                    number={this.state.medias + ''}
                                    text={'Tài liệu'}
                                    icon="ion-android-document"
                                    fontColor="#ffffff"
                                    bgColor="#364153"
                                />
                            </IsoWidgetsWrapper>
                        </Col>

                        <Col lg={6} md={12} sm={12} xs={24} style={colStyle}>
                            <IsoWidgetsWrapper>
                                {/* Sticker Widget */}
                                <StickerWidget
                                    number={this.state.objects + ''}
                                    text={'Đối tượng'}
                                    icon="ion-planet"
                                    fontColor="#ffffff"
                                    bgColor="#355563"
                                />
                            </IsoWidgetsWrapper>
                        </Col>
                    </Row>
                    {this.props.userInfo &&
                        this.props.userInfo.tier_id === 100 && (
                            <ListPageLinks />
                        )}

                    <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={24}
                        style={{ padding: 20 }}
                    >
                        <ChartEventStatisticsByObject />
                    </Col>
                    <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={24}
                        style={{ padding: 20 }}
                    >
                        <ChartObjectEvent />
                    </Col>
                    <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ padding: 20 }}
                    >
                        <ChartUserTask />
                    </Col>
                    <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={24}
                        style={{ padding: 20 }}
                    >
                        <ChartOrgTask />
                    </Col>
                    <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={24}
                        style={{ padding: 20 }}
                    >
                        <ChartUserCollected />
                    </Col>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.app,
        userInfo: state.auth.userInfo,
        isLogin: state.home.isLogin,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        logout: () => {
            dispatch(authActions.action.logout())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HomePage)
